<template>
  <Dialog class="mobile reward-box-dialog" :modelValue="props.modelValue" @update:modelValue="updateModelValue" type="common" :showClose="true">
    <div class="content">
      <div class="props-wrap" v-if="props.rewardData.rewardCode !== 'super_box'">
        <div class="prop" :class="`prop-${index}`" v-for="(item, index) in props.rewardData.rewardItems" :key="index">
          <div class="icon-wrap">
            <img :class="`prop-${index}`" :src="`${PUBLIC_PATH}imgs/props/${item.itemId}.png`" alt="icon">
          </div>
          <div class="prop-name">
            {{ $t(`props.${item.itemId}`) }}
          </div>
          <div class="prop-count">
            *{{ item.quantity }}
          </div>
        </div>
      </div>
      <div class="super_box_wrap" v-if="props.rewardData.rewardCode === 'super_box'">
        <div class="super_box_icon"></div>
        <div class="super_box_num"></div>
      </div>
      <div class="box-icon" :class="props.rewardData.rewardCode"></div>
    </div>
  </Dialog>
</template>
<script setup>
import Dialog from '@/components/Dialog/ActMwr/index.vue'
import { defineProps, defineEmits } from 'vue'
const PUBLIC_PATH = process.env.VUE_APP_PUBLIC_PATH
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  rewardData: {
    type: Object,
    default: () => {}
  }
})
const emit = defineEmits(['update:modelValue'])
const updateModelValue = (value) => {
  emit('update:modelValue', value)
}
</script>

<style lang="less" scoped src="./mobile_style.less"></style>
